<template>
  <section class="relative w-full">
    <!-- Desktop screen version -->
    <div
      class="warranty-hero-bg-section relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain h-[480px] md:h-[600px] lg:h-[650px] xl:h-[742px] xl:block', ]"
    >
      <div class="container md:relative absolute top-[120px] xl:top-[164px]">
        <div
          class="border-b-4 border-primary-500 ml-0.5 md:border-b-[6px] skew-x-[-25deg] w-[108px]"
        />

        <h1
          class="text-[34px] md:text-4xl xl:tracking-[0.56px] leading-[40px] md:leading-[3rem] xl:text-[56px] xl:leading-[60px] flex font-ff-good-pro-cond font-bold italic text-start text-white mt-3 xl:mt-[41px] mb-0"
        >
          <span> {{ title }}</span>
          &nbsp;
          <span class="lowercase text-primary-500"> {{ secondaryTitle }}</span>
        </h1>
        <p
          class="w-[299px] text-[15px] md:text-[22px] md:leading-8 italic leading-6 md:w-[440px] xl:w-[540px] font-ff-good-pro-cond font-normal text-start text-white pt-3 lg:pt-[24px] pb-3 lg:pb-[40px]"
          v-html="description"
        ></p>
        <div class="flex justify-start">
          <div>
            <Btn
              type="button"
              size="xl"
              block
              :rounded="false"
              class="rounded-md"
              color="white"
              @click="openWarrantyModal"
            >
              <span
                class="text-lg font-bold leading-6 text-center text-black uppercase"
              >
                {{ $t("common.warranty_request") }}
              </span>
            </Btn>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Version Banner cover Section-->
    <div
      class="relative block bg-black lg:hidden md:hidden"
      data-aos="fade-left"
      data-aos-delay="100"
      data-aos-offset="100"
    >
      <img
        class="relative w-full h-[480px] object-cover"
        src="../public/warranty/mobile_hero_bg.png"
        alt="Become dealer mobile image"
      />

      <div
        class="container md:relative md:top-0 top-auto bottom-8 md:bottom-auto pt-[30px] pb-[60px]"
      >
        <div
          class="border-b-4 skew-x-[-50deg] border-primary-500 w-[69px] md:w-[108px] h-1 lg:h-[6px] absolute md:mt-[99px] mb-[31px]"
        ></div>
        <h1
          class="text-[32px] leading-[40px] tracking-[0.32px] flex font-ff-good-pro-cond italic mb-0 font-bold w-full pr-8 text-white mt-[16px]"
        >
          <span> {{ title }}</span> &nbsp;
          <span class="text-primary-500">{{ secondaryTitle }}</span>
        </h1>
        <p
          class="text-lg leading-7 mb-[30px] font-ff-good-pro-cond font-normal w-full italic text-start text-white pt-[14px]"
          v-html="description"
        />
        <Btn
          type="button"
          size="xl"
          block
          :rounded="false"
          class="rounded-md"
          color="white"
          @click="openWarrantyModal"
        >
          <span
            class="text-lg font-bold leading-6 text-center text-black uppercase"
          >
            {{ $t("common.warranty_request") }}
          </span>
        </Btn>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useModal } from "vue-final-modal";
import WarrantyModal from "~/modals/WarrantyRequestForm.vue";

import { useTranslation } from "i18next-vue";

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  secondaryTitle: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
  imageUrl: {
    type: String,
    default: "dealer",
  },
});
function openWarrantyModal() {
  console.log("Opening modal...");
  const { open, close } = useModal({
    component: WarrantyModal,
    attrs: {
      isChangeDir: true,
    },
  });
  open();
}
</script>

<style>
.warranty-hero-bg-section {
  background-image: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 43.51%,
      rgba(0, 0, 0, 0.5) 66.7%,
      rgba(0, 0, 0, 0.7) 102.81%
    ),
    url("../public/warranty/hero_bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  @apply md:bg-cover;
}
</style>
